import UserImage from "@/components/utils/UserImage";
import { Investor } from "@/models/crunchbase/Investor";
import { Funder } from "@/types/FunderTypes";
import { Box, Typography } from "@mui/material";
import BaseFunderTemplate from "./BaseFunderTemplate";

interface Props {
  funder: Funder;
}

const InvestorTemplate = (props: Props) => {
  const investor = props.funder.entity as Investor;
  const numberOfFoundedOrg = props?.funder?.investorAdditionalFields?.organizationFoundedCount;
  return (
    <BaseFunderTemplate>
      <>
        <Box className="header">
          <UserImage src={investor.logoUrl} company />
          <Typography>{investor.name}</Typography>
        </Box>

        <Typography>
          {investor?.roles
            .split(",")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(", ")}
        </Typography>
        <Box className="footer">
          {numberOfFoundedOrg !== null && (
            <Box>
              <Typography className="grey-text">Number of Founded Organizations</Typography>
              <Typography>{numberOfFoundedOrg}</Typography>
            </Box>
          )}
          <Box>
            <Typography className="grey-text">CB Rank (Investor)</Typography>
            <Typography>{investor.rank}</Typography>
          </Box>
        </Box>
      </>
    </BaseFunderTemplate>
  );
};
export default InvestorTemplate;
